import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Message16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_393)'>
      <path
        d='M12.5 8C12.5 8.55228 12.0523 9 11.5 9C10.9477 9 10.5 8.55228 10.5 8C10.5 7.44772 10.9477 7 11.5 7C12.0523 7 12.5 7.44772 12.5 8Z'
        fill='currentColor'
      />
      <path
        d='M8 9C8.55228 9 9 8.55228 9 8C9 7.44772 8.55228 7 8 7C7.44772 7 7 7.44772 7 8C7 8.55228 7.44772 9 8 9Z'
        fill='currentColor'
      />
      <path
        d='M5.5 8C5.5 8.55228 5.05228 9 4.5 9C3.94772 9 3.5 8.55228 3.5 8C3.5 7.44772 3.94772 7 4.5 7C5.05228 7 5.5 7.44772 5.5 8Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.00004 15.75H7.99993C12.2801 15.75 15.75 12.2802 15.75 8C15.75 3.71979 12.2802 0.25 8 0.25C3.71979 0.25 0.25 3.71979 0.25 8C0.25 9.75949 0.837111 11.3833 1.82529 12.6841L0.404035 14.5447C0.0344229 15.0286 0.39116 15.75 1.00004 15.75ZM1.75 8C1.75 4.54822 4.54822 1.75 8 1.75C11.4518 1.75 14.25 4.54822 14.25 8C14.25 11.4518 11.4518 14.25 8 14.25H7.99894H2.51673L3.37843 13.1219C3.59698 12.8358 3.58139 12.4348 3.34127 12.1665C2.35116 11.0602 1.75 9.60122 1.75 8Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_393'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Message16.displayName = 'Message16';
export default Message16;
